import { useState } from "react";
import { createPost } from "../graphql/mutations"; 
import { generateClient } from 'aws-amplify/api';


interface JobProps {
  onClose: () => void; 
}

const AddJobPage: React.FC<JobProps> = ({ onClose }) => {
  const [title, setTitle] = useState<string>("");
  const [location, setLocation] = useState<string>("");
  const [type, setType] = useState<string>("");
  const [description, setDescription] = useState<string[]>([]);
  const [descriptionInput, setDescriptionInput] = useState<string>("");

  const [formError, setFormError] = useState<string>("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setFormError("");

    if (!title || !location || !type || description.length === 0) {
      setFormError("Please fill in all the fields and add at least one description.");
      return;
    }

    try {
      const data = {
        title,
        location,
        type,
        description,
      };
      const client = generateClient();
      const result = await client.graphql({
        query: createPost,
        variables: { input: data },
      });

      if (result) {
        alert("Job added successfully!");
        onClose(); 
      }
    } catch (error: any) {
      setFormError(error.message || "An error occurred while adding the job.");
    }
  };

  const addDescription = () => {
    if (descriptionInput.trim()) {
      setDescription([...description, descriptionInput]);
      setDescriptionInput(""); 
    }
  };

  return (
    <div className="main">
      <div className="border p-5 rounded-3xl shadow-lg mx-auto mt-20 bg-white max-w-2xl">
        <h1 className="text-2xl mb-4 font-bold text-center">Add Job</h1>
        <form onSubmit={handleSubmit} className="space-y-4 md:space-y-6">
          <div>
            <label
              htmlFor="title"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Job Title
            </label>
            <input
              type="text"
              id="title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
              placeholder="Job title"
              required
            />
          </div>
          <div>
            <label
              htmlFor="location"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Location
            </label>
            <input
              type="text"
              id="location"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
              placeholder="Location"
              required
            />
          </div>
          <div>
            <label
              htmlFor="type"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Employment Type
            </label>
            <input
              type="text"
              id="type"
              value={type}
              onChange={(e) => setType(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
              placeholder="Full Time, Part Time, Casual, Subcontractor."
              required
            />
          </div>
          <div>
            <label
              htmlFor="description"
              className="block mb-2 text-sm font-medium text-gray-900"
            >
              Job Description
            </label>
            <textarea
              id="description"
              value={descriptionInput}
              rows={2}
              onChange={(e) => setDescriptionInput(e.target.value)}
              className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm rounded-lg focus:ring-blue-600 focus:border-blue-600 block w-full p-2.5"
              placeholder="Add a description line"
            />
            <button
              type="button"
              onClick={addDescription}
              className="mt-2 bg-blue-500 text-white px-4 py-2 rounded"
            >
              Add Description
            </button>
            <div>
              {description.map((desc, index) => (
                <p key={index} className="mt-2 text-gray-600">
                  {index + 1}. {desc}
                </p>
              ))}
            </div>
          </div>
          {formError && <p className="text-red-500 text-sm">{formError}</p>}
          <button
            type="submit"
            className="w-full text-white bg-blue-600 hover:bg-blue-700 rounded-lg text-sm px-5 py-2.5 text-center font-bold"
          >
            Add Job
          </button>
        </form>
        <div className="mt-4 text-center">
          <button type="button" onClick={onClose} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddJobPage;
